// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3AECX","upload":"Small_upload__28_CV","imageWrap":"Small_imageWrap__3dSw8","removeBtn":"Small_removeBtn__2OqBW"};